import { render, staticRenderFns } from "./cart-list-detail.vue?vue&type=template&id=15d21db6"
import script from "./cart-list-detail.vue?vue&type=script&lang=js"
export * from "./cart-list-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports